<template>
  <div style="background-color: white;position:relative" class="pa-1 itinerairemaps">
    <full-calendar :options="calendarOptions" height="100px" />
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";

export default {
  props: {
    calendarOptions: {},
  },
  components: {
    FullCalendar,
  },
};
</script>

<style>
</style>